import { observer } from "mobx-react";
import React, { useState, useCallback, useEffect } from "react";
import { withSize } from "react-sizeme";
import { toast } from "react-toastify";
import { ColumnType } from "../../constants/enums/gridColumnTypeEnum";
import { useStore } from "../../contexts/StoreProvider";
import useWindowDimensions from "../../helpers/windowResize.helper";
import { ISorting } from "../../models/ISorting";
import Grid, { getColumns } from "../../shared-components/Grid/Grid";
import SearchField from "../../shared-components/SearchField/SearchField";
import { formatMessage } from "../../translations/formatMessage";
import Pagination from "../../shared-components/Grid/Pagination";
import { IUser } from "../../models/IUser";
import IPageInfo from "../../models/IPageInfo";
import { IActionFormatter, IFormatter } from "../../models/IFormatter";
import Avatar from "../../assets/Images/defaultImages2.png";
import { notAvailable } from "../../constants/common-constant";

import {
  PageLimitOptions,
  initialPageLimit,
} from "../../constants/pageLimit.constant";
import { Button, Card, Container, Dropdown } from "react-bootstrap";
import DeletePopup from "../../shared-components/Popup/DeletePopup";
import DeletePopupHOC from "../../shared-components/Popup/Hoc/DeletePopupHoc";
import AddUser from "./AddUser";
import AddPopupHOC from "../../shared-components/Popup/Hoc/AddPopupHoc";
import EditPopupHOC from "../../shared-components/Popup/Hoc/EditPopupHoc";
import { Col, ListGroup, Row } from "react-bootstrap";
import "./User.scss";
import Footer from "../../shared-components/Footer/Footer";
import SubHeader from "../../shared-components/Header/SubHeader";
import UserType from "../../constants/userType.constant";
import { getClientId, getUserType } from "../../helpers/localStorages.helper";
import { FilterPopupHOC } from "../../shared-components/Filters/FilterPopupHOC";
import UserFilterForm from "./forms/user-filter-form";
import { ModuleName } from "../../constants/moduleName.constant";
import { FormattedMessage } from "react-intl";
import SpinnerLoader from "../../shared-components/Loader/SpinnerLoader";
import NoData from "../../assets/Images/no_record.png";
import { getUserTypeStyleClass } from "../../constants/common-constant";
import _ from "lodash";
import { userInitialFilterState } from "../../core/initialState/initial-filter-states";
import UrlConstants from "../../constants/url.constant";
interface IProps {
  size: { height: number };
  showDeletePopup: boolean;
  deleteToggleHandler: () => void;
  showAddPopup: boolean;
  addToggleHandler: () => void;
  showEditPopup: boolean;
  editToggleHandler: () => void;
  showFilterPopup: boolean;
  filterToggleHandler: () => void;
}

const User: React.FC<IProps> = (props: IProps) => {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const { userStore, preferencesStore, roleStore, customerStore } = useStore();
  const {
    showDeletePopup,
    deleteToggleHandler,
    showAddPopup,
    addToggleHandler,
    showFilterPopup,
    filterToggleHandler,
  } = props;
  const {
    inProgress,
    userData,
    getAllUser,
    allUser,
    reset,
    resetError,
    deleteUser,
    deleteUserState,
    addNewUserSuccess,
    errors,
    filter,
    setFilterDetail,
    totalUsers,
  } = userStore;
  const { GetAllRolesService } = roleStore;
  const { GetAllCustomerService } = customerStore;
  const {
    selectedClientId,
    setSelectedClientId,
    setAmountDecimal,
    CSVFileDownloadPostService,
    allAvailableClientOptions,
    resetClientListState,
    clientList,
    setEnableLimitSettings,
  } = preferencesStore;

  const [selectedId, setSelectedId] = useState<number>(-1);
  const [changeDetails, setChangeDetails] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const allUsersData: Array<IUser> = allUser;
  const [pageLimitForUser, setPageLimitForUser] =
    useState<number>(initialPageLimit);
  const [searchTextForUser, setSearchTextForUser] = useState("");
  const [sortingForUser, setSortingForUser] = useState<ISorting>({
    column: "user_name",
    orderBy: "asc",
  });
  const [isApiCalled, setIsApiCalled] = useState<boolean>(false);

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
  });

  const { height, width } = useWindowDimensions();

  const onPageChanged = useCallback((pageNumber: number) => {
    setPageInfo((pageInfo) => ({ ...pageInfo, currentPage: pageNumber }));
  }, []);

  const onPageLimitChangedForUser = (
    evt: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setPageLimitForUser(parseInt(evt.target.value));
  };

  const onSearchTextChangedForUser = (text: string) => {
    setSearchTextForUser(text);
  };

  /**
   * This function provides filtering functionality of data on the basis of client id
   */
  const clientSelectHandler = (e: {
    label: string;
    value: number;
    key: number;
  }) => {
    let value = e.value;
    if (value < 0) toast.error(formatMessage("please_select_any_client_admin"));
    else {
      resetFilterHandler();
      setSelectedClientId(value);
      setAmountDecimal(value);
      setEnableLimitSettings(value);
      setPageInfo({ ...pageInfo, currentPage: 1 });
    }
  };

  const callGetAllUserService = useCallback(() => {
    setDisablePagination(true);
    if (getUserType() === UserType.SuperAdmin) {
      if (selectedClientId > 0 && clientList.length > 0) {
        getAllUser(
          pageInfo.currentPage,
          pageLimitForUser,
          sortingForUser.orderBy,
          sortingForUser.column,
          searchTextForUser,
          _.omit(filter, ["isFilterActive"])
        );
      }
    } else {
      getAllUser(
        pageInfo.currentPage,
        pageLimitForUser,
        sortingForUser.orderBy,
        sortingForUser.column,
        searchTextForUser,
        _.omit(filter, ["isFilterActive"])
      );
    }
    setIsApiCalled(true);
  }, [
    getAllUser,
    pageInfo.currentPage,
    pageLimitForUser,
    sortingForUser.orderBy,
    sortingForUser.column,
    searchTextForUser,
    selectedClientId,
    filter,
    clientList.length,
  ]);

  // useEffect(() => {
  //   if (selectedClientId) {
  //     if (getUserType() == UserType.SuperAdmin) {
  //       if (selectedClientId != -1) callGetAllUserService();
  //       else return;
  //     } else callGetAllUserService();
  //   }
  // }, [selectedClientId]);

  // useEffect(() => {
  //   if (isApiCalled) {
  //     // showUserDetailToggleHandler();
  //     setIsApiCalled(false);
  //   }
  // }, [isApiCalled]);

  useEffect(() => {
    return () => {
      resetFilterHandler();
      resetClientListState();
    };
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "filter" of the useEffect changed.
   */
  // useEffect(() => {
  //   if (selectedClientId > 0 && filter.isFilterActive) {
  //     if (getUserType() == UserType.SuperAdmin) {
  //       if (selectedClientId != -1) callGetAllUserService();
  //       else return;
  //     } else callGetAllUserService();
  //   }
  //   else{
  //     if (getUserType() == UserType.SuperAdmin) {
  //       if (selectedClientId != -1) callGetAllUserService();
  //       else return;
  //     } else callGetAllUserService();
  //     }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filter, selectedClientId,callGetAllUserService]);

  useEffect(() => {
    if (selectedClientId > 0) callGetAllUserService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, selectedClientId, callGetAllUserService]);

  useEffect(() => {
    setPageInfo((pageInfo) => ({
      ...pageInfo,
      totalPages: userData?.TotalPages,
    }));
    setDisablePagination(false);
  }, [allUser, userData.TotalPages]);

  useEffect(() => {
    if (addNewUserSuccess) {
      callGetAllUserService();
    }
  }, [addNewUserSuccess, callGetAllUserService]);

  useEffect(() => {
    if (errors) {
      toast.error(formatMessage(errors));
      resetError();
    }
  }, [errors, resetError]);

  useEffect(() => {
    if (deleteUserState.success) {
      toast.success(formatMessage("message_user_delete_success"));
      reset();
      deleteToggleHandler();
      callGetAllUserService();
    }
  }, [deleteUserState.success, reset, callGetAllUserService]);

  useEffect(() => {
    if (deleteUserState.error) {
      toast.error(formatMessage(deleteUserState.error));
      // toast.error(formatMessage("message_user_delete_failed"));
      resetError();
    }
  }, [deleteUserState.error, resetError]);

  const filterSubmitHandler = (values: any) => {
    // closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: 1 });
    // setFilterData({...values, isFilterActive: true});
    setFilterDetail({ ...values, isFilterActive: true });
    props.filterToggleHandler();
  };

  const resetFilterHandler = () => {
    // setPageInfo({ ...pageInfo, currentPage: 1 });
    setFilterDetail({ ...userInitialFilterState });
  };

  const openAddUserHandler = (row: { Id: number }) => {
    GetAllRolesService();
    GetAllCustomerService();
    setSelectedId(row.Id);
    setChangeDetails(false);
    addToggleHandler();
  };

  const openFilterHandler = () => {
    filterToggleHandler();
  };

  const exportFilteredLogsCSV = () => {
    const clientIdFromLocalStorage = getClientId() != null ? getClientId() : -1;
    const url = `${UrlConstants.UserCSVDownload}?clientId=${clientIdFromLocalStorage}`;
    let tempFilterDetails = { ..._.omit(filter, ["isFilterActive"]) };
    tempFilterDetails = {
      ...tempFilterDetails,
      IsActive:
        filter.IsActive == "2" ? null : filter.IsActive == "1" ? false : true,
      UserType: filter.UserType == -1 ? null : filter.UserType,
    };
    CSVFileDownloadPostService(url, "User", tempFilterDetails);
  };

  const deleteHandler = () => {
    deleteUser(selectedId);
  };

  const deleteClickHandler = (row: { Id: number }) => {
    setSelectedId(row.Id);
    setChangeDetails(false);
    deleteToggleHandler();
  };

  const showDetailsClickHandler = (row: { Id: number }) => {
    setSelectedId(row.Id);
    setChangeDetails(true);
    // !showUserDetail && showUserDetailToggleHandler();
    setIsApiCalled(false);
  };

  const handleSortingChange = (accessor: string) => {
    let sortOrder = sortingForUser.orderBy;
    if (accessor === sortingForUser.column) {
      sortOrder = sortingForUser.orderBy === "asc" ? "desc" : "asc";
    }
    setSortingForUser({ column: accessor, orderBy: sortOrder });
  };

  const addIcons: Array<IActionFormatter<string>> = [
    {
      handler: openAddUserHandler,
      icon: (
        <svg height="14" viewBox="0 0 492.49284 492" width="14">
          <path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" />
          <path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" />
        </svg>
      ),
      // key: "IsEditable",
      key: "",
      title: "label_edit",
      className: "btn-warning",
    },
    {
      handler: deleteClickHandler,
      icon: (
        <svg
          version="1.1"
          x="0px"
          y="0px"
          width="13"
          height="13"
          viewBox="0 0 512 512"
        >
          <g>
            <g>
              <path
                d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"
              />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      ),
      // key: "IsDeletable",
      key: "",
      title: "label_delete",
      className: "btn-danger",
    },
    {
      handler: showDetailsClickHandler,
      icon: (
        <svg
          enableBackground="new 0 0 519.643 519.643"
          width="13"
          height="13"
          viewBox="0 0 519.643 519.643"
        >
          <circle cx="259.823" cy="259.866" r="80" />
          <path d="m511.673 237.706c-61.494-74.31-154.579-145.84-251.85-145.84-97.29 0-190.397 71.58-251.85 145.84-10.63 12.84-10.63 31.48 0 44.32 15.45 18.67 47.84 54.71 91.1 86.2 108.949 79.312 212.311 79.487 321.5 0 43.26-31.49 75.65-67.53 91.1-86.2 10.599-12.815 10.654-31.438 0-44.32zm-251.85-89.84c61.76 0 112 50.24 112 112s-50.24 112-112 112-112-50.24-112-112 50.24-112 112-112z" />
        </svg>
      ),
      key: "",
      title: "label_showdetails",
      className: "btn-secondary",
    },
  ];

  const columns = getColumns<IUser, number>(
    [
      {
        columnType: ColumnType.Hidden,
        accessorKey: "Id",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "UserName",
        sortingName: "user_name",
        displayName: "user_label_username",
      },
      {
        columnType: ColumnType.ActionsFormatter,
        icons: addIcons,
        displayName: "label_action",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "PhoneNo",
        sortingName: "contact_no",
        displayName: "user_label_contactnumber",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "WhatsAppNo",
        sortingName: "whatsapp_number",
        displayName: "user_label_whatsappnumber",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "Address",
        sortingName: "address",
        displayName: "user_label_address",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "City",
        sortingName: "city",
        displayName: "user_label_city",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "State",
        sortingName: "state",
        displayName: "user_label_state",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "Country",
        sortingName: "country",
        displayName: "user_label_country",
      },
      {
        columnType: ColumnType.Sorting,
        accessorKey: "RoleId",
        sortingName: "role_id",
        displayName: "user_label_roleid",
      },
    ],
    sortingForUser,
    handleSortingChange
  );

  return (
    <React.Fragment>
      {showAddPopup && (
        <AddUser
          id={selectedId}
          from={ModuleName.User}
          modalClosed={addToggleHandler}
        />
      )}

      {showFilterPopup && (
        <UserFilterForm
          initialValues={_.omit(filter, ["isFilterActive"])}
          submitHandler={filterSubmitHandler}
          onModalClosed={filterToggleHandler}
          actionInProgress={false}
          roleList={[]}
        />
      )}

      {showDeletePopup && (
        <DeletePopup
          modalSubmit={deleteHandler}
          modalClosed={deleteToggleHandler}
          isLoading={deleteUserState.inProgress}
          message="user_message_delete_confirm"
          submitBtnText={"submit_button"}
          cancelBtnText={"button_cancel"}
          modalTitle={"delete_user"}
        />
      )}

      {/* <div className={`main-content user ${showUserDetail ? 'table-container' : ''} `}> */}
      <div className={`main-content user`}>
        <SubHeader
          setIsFullScreen={setIsFullScreen}
          moduleNameString={"user_title"}
          moduleName={ModuleName.User}
          addHandler={openAddUserHandler}
          filterHandler={openFilterHandler}
          exportCSVHandler={exportFilteredLogsCSV}
          isAdd={
            getUserType() == UserType.SuperAdmin
              ? selectedClientId > 0
                ? true
                : false
              : true
          }
          isFilterActive={filter.isFilterActive}
          resetFilterHandler={resetFilterHandler}
          showClientSelectHandler={true}
          clientSelectHandler={clientSelectHandler}
          addButtonTitle="user_title_add"
          isFullView={false}
          isDownload={true}
          isRefresh={false}
          isFilter={true}
          isDateFilter={false}
          isImport={false}
          isMissing={false}
          isSelectAssetId={false}
          isDeleteAlarm={false}
        />
      </div>
      {inProgress && <SpinnerLoader />}
      <Container fluid className="p-0">
        {allUsersData.length !== 0 ? (
          <div className="userWrapper background-image">
            <div className="pt-3 px-3">
              <div
                className={` ${allUsersData.length > 0 ? "blank_height" : ""}`}
              >
                <Row className="g-3">
                  <div className="Total-users d-flex justify-content-end mt-2">
                    <FormattedMessage id="Total Users" /> :{" "}
                    <b className="ps-1"> {totalUsers}</b>
                  </div>
                  {allUsersData.map((user: IUser) => {
                    return (
                      <Col
                        lg={3}
                        md={4}
                        sm={6}
                        xs={12}
                        className="mb-2"
                        key={user.Id}
                      >
                        <Card className="rounded shadow-sm arrowUp position-relative  h-100 m-auto">
                          <div className="user-list pb-3 pt-2">
                            <div className="d-flex justify-content-between">
                              <div>
                                <span
                                  className={`badge badge-pill badge-primary ms-3 ${getUserTypeStyleClass(
                                    user.UserType
                                  )}`}
                                >
                                  <FormattedMessage id={user.UserType} />
                                </span>
                                <small className="userAdmin ms-3 fs-11 fw-semi-bold">
                                  {user.RoleName && user.RoleName}
                                </small>
                              </div>
                              <div></div>
                              <Dropdown className="border-0 enable-caret editButton">
                                <Dropdown.Toggle
                                  variant=""
                                  id="dropdown-basic"
                                  className="shadow-none p-0 ViewAll pe-3"
                                >
                                  <span>
                                    {" "}
                                    <i className="fas fa-ellipsis-v"></i>
                                  </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu-start p-0">
                                  <Dropdown.Item
                                    className="d-flex align-items-center pb-0"
                                    onClick={() => {
                                      openAddUserHandler({ Id: user.Id });
                                    }}
                                    title="Edit"
                                  >
                                    <div className="">
                                      <svg
                                        height="14"
                                        viewBox="0 0 492.49284 492"
                                        width="14"
                                        fill="#fff"
                                      >
                                        <path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" />
                                        <path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" />
                                      </svg>
                                    </div>
                                    <div className="ps-2 fs-6 text-white">
                                      <a
                                        className="dropdown-item  p-0 pt-1"
                                        href="javascript:;"
                                      >
                                        <FormattedMessage id="label_edit" />
                                      </a>
                                    </div>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    className="d-flex align-items-center"
                                    onClick={() => {
                                      deleteClickHandler({ Id: user.Id });
                                    }}
                                    title="Delete"
                                  >
                                    <div className="">
                                      <svg
                                        version="1.1"
                                        x="0px"
                                        y="0px"
                                        width="13"
                                        height="13"
                                        fill="#fff"
                                        viewBox="0 0 512 512"
                                      >
                                        <g>
                                          <g>
                                            <path
                                              d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
  L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
  c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
  c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
  c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
  c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"
                                            />
                                          </g>
                                        </g>
                                        <g>
                                          <g>
                                            <path
                                              d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
  c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
  c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"
                                            />
                                          </g>
                                        </g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                      </svg>
                                    </div>
                                    <div className="ps-2 fs-6 text-white">
                                      <a
                                        className="dropdown-item  p-0 pt-1"
                                        href="javascript:;"
                                      >
                                        <FormattedMessage id="label_delete" />
                                      </a>
                                    </div>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>

                            <div className="row mt-3">
                              <div className="d-flex align-items-center user-content">
                                <div>
                                  <div className="avatar_user shadow">
                                    <img
                                      src={
                                        user.ProfileImage
                                          ? user.ProfileImage
                                          : Avatar
                                      }
                                      className="roundedCircle"
                                      alt="UserProfile"
                                    />
                                    <span
                                      className={`status ${
                                        user.IsActive ? "online" : "offline"
                                      }`}
                                    ></span>
                                  </div>
                                </div>
                                <div className="user-content ps-3">
                                  <h4 className="user-name fw-semi-bold mb-0 text-break">
                                    {user.UserName}
                                  </h4>

                                  <small className="text-muted fw-normal text-break">
                                    {user.CustomerName && user.CustomerName}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="call">
                            <Row>
                              <Col lg="12" className="mb-2">
                                {user.Email && (
                                  <div className="d-flex justify-content-start">
                                    <div>
                                      <div className="circle-icon purple">
                                        <svg
                                          viewBox="0 0 24 24"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g id="Layer_2" data-name="Layer 2">
                                            <path d="m19 20.5h-14a4.00427 4.00427 0 0 1 -4-4v-9a4.00427 4.00427 0 0 1 4-4h14a4.00427 4.00427 0 0 1 4 4v9a4.00427 4.00427 0 0 1 -4 4zm-14-15a2.00229 2.00229 0 0 0 -2 2v9a2.00229 2.00229 0 0 0 2 2h14a2.00229 2.00229 0 0 0 2-2v-9a2.00229 2.00229 0 0 0 -2-2z" />
                                            <path d="m12 13.43359a4.99283 4.99283 0 0 1 -3.07031-1.0542l-6.544-5.08984a1.00035 1.00035 0 0 1 1.22852-1.5791l6.54394 5.08984a2.99531 2.99531 0 0 0 3.6836 0l6.54394-5.08984a1.00035 1.00035 0 0 1 1.22852 1.5791l-6.544 5.08984a4.99587 4.99587 0 0 1 -3.07021 1.0542z" />
                                          </g>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className="ps-2 fs-6 ">
                                      {" "}
                                      {user.Email}
                                    </div>{" "}
                                  </div>
                                )}
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <div className="d-flex justify-content-start">
                                  <div>
                                    <div className="circle-icon green">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        data-name="Layer 1"
                                        viewBox="0 0 64 64"
                                      >
                                        <path d="M60.85,46.11a4.74,4.74,0,0,0-2.41-3L46.07,36.7a4.71,4.71,0,0,0-6,1.37l-2,2.74a.72.72,0,0,1-.93.21,36.3,36.3,0,0,1-8-6.17,36.31,36.31,0,0,1-6.17-8,.72.72,0,0,1,.21-.93l2.73-2a4.71,4.71,0,0,0,1.37-6L20.91,5.56A4.73,4.73,0,0,0,14.09,3.8L6.32,9A7.48,7.48,0,0,0,3,15.69a37.64,37.64,0,0,0,.89,6.57C6,30.4,11.09,38.77,18.16,45.85S33.61,58,41.75,60.09a37.67,37.67,0,0,0,6.57.89l.5,0A7.48,7.48,0,0,0,55,57.69l5.18-7.77A4.73,4.73,0,0,0,60.85,46.11Zm-4,1.58L51.7,55.47A3.5,3.5,0,0,1,48.58,57a34.57,34.57,0,0,1-5.83-.77C35.29,54.29,27.57,49.6,21,43S9.72,28.71,7.78,21.25A34.54,34.54,0,0,1,7,15.42a3.47,3.47,0,0,1,1.53-3.11l7.77-5.18a.71.71,0,0,1,.4-.12l.19,0a.72.72,0,0,1,.46.37l6.4,12.37a.73.73,0,0,1-.21.92l-2.73,2a4.72,4.72,0,0,0-1.28,6.13,40.54,40.54,0,0,0,6.8,8.81,40.52,40.52,0,0,0,8.81,6.8,4.72,4.72,0,0,0,6.13-1.28l2-2.74a.73.73,0,0,1,.92-.21l12.37,6.4a.73.73,0,0,1,.27,1.05Z" />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="ps-2 fs-6 text-break">
                                    {user.PhoneNo ? (
                                      <>{user.PhoneNo} </>
                                    ) : (
                                      formatMessage(notAvailable)
                                    )}
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <div className="d-flex justify-content-start">
                                  <div className="circle-icon yellow">
                                    <svg
                                      version="1.1"
                                      id="Layer_1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 308 308"
                                    >
                                      <g id="XMLID_468_">
                                        <path
                                          id="XMLID_469_"
                                          d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
        c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
        c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
        c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
        c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
        c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
        c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
        c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
        c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
        C233.168,179.508,230.845,178.393,227.904,176.981z"
                                        />
                                        <path
                                          id="XMLID_470_"
                                          d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
        c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
        c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
        M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
        l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
        c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
        C276.546,215.678,222.799,268.994,156.734,268.994z"
                                        />
                                      </g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                      <g></g>
                                    </svg>
                                  </div>
                                  <div className="ps-2 fs-6 text-break">
                                    {user.WhatsAppNo ? (
                                      <> {user.WhatsAppNo}</>
                                    ) : (
                                      formatMessage(notAvailable)
                                    )}
                                  </div>{" "}
                                </div>
                              </Col>
                              <Col lg="12" className="mt-2">
                                {user.Address && (
                                  <div className="d-flex justify-content-start">
                                    <div>
                                      <div className="circle-icon maroon">
                                        <svg
                                          version="1.1"
                                          id="Capa_1"
                                          xmlns="http://www.w3.org/2000/svg"
                                          x="0px"
                                          y="0px"
                                          viewBox="0 0 511.999 511.999"
                                        >
                                          <g>
                                            <g>
                                              <path
                                                d="M409.124,63.426C368.224,22.525,313.843,0,256.001,0S143.777,22.525,102.877,63.426
			c-40.901,40.902-63.426,95.282-63.426,153.123c0,117.012,110.638,214.337,170.077,266.623c8.26,7.266,15.393,13.541,21.076,18.849
			c7.12,6.651,16.259,9.977,25.396,9.977c9.139,0,18.276-3.326,25.397-9.977c5.683-5.309,12.816-11.583,21.076-18.849
			c59.439-52.287,170.077-149.611,170.077-266.623C472.549,158.708,450.025,104.328,409.124,63.426z M282.663,460.654
			c-8.441,7.425-15.73,13.838-21.74,19.451c-2.761,2.577-7.085,2.578-9.847,0c-6.009-5.615-13.299-12.027-21.74-19.452
			c-55.88-49.155-159.895-140.654-159.895-244.103c0-102.868,83.689-186.557,186.558-186.557
			c102.868,0,186.557,83.689,186.557,186.557C442.557,319.999,338.543,411.498,282.663,460.654z"
                                              />
                                            </g>
                                          </g>
                                          <g>
                                            <g>
                                              <path
                                                d="M256.001,112.938c-52.621,0-95.431,42.809-95.431,95.43s42.81,95.43,95.431,95.43s95.43-42.809,95.43-95.43
			S308.622,112.938,256.001,112.938z M256.001,273.805c-36.083,0-65.439-29.356-65.439-65.438s29.356-65.438,65.439-65.438
			s65.438,29.356,65.438,65.438S292.084,273.805,256.001,273.805z"
                                              />
                                            </g>
                                          </g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                          <g></g>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className="ps-2 fs-6 text-break">
                                      {" "}
                                      {user.Address}, {user.City}, {user.State}{" "}
                                      , {user.Country}
                                    </div>{" "}
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
                {/* {
            allUsersData.length == 0 &&
            <div className="no_data mt-5 pt-5 text-center">
              <svg height="90" viewBox="0 0 64 64" width="90" xmlns="http://www.w3.org/2000/svg"><g id="Error"><rect fill="#50d9d7" height="45" rx="2" width="58" x="6" /><path d="m51 52h-34v-52h19.53a4 4 0 0 1 3.58 2.21l.78 1.58a4 4 0 0 0 3.58 2.21h6.53z" fill="#93e6e5" /><path d="m64 6v44a2 2 0 0 1 -2 2h-60a2 2 0 0 1 -2-2v-48a2 2 0 0 1 2-2h17.53a4 4 0 0 1 3.58 2.21l.78 1.58a4 4 0 0 0 3.58 2.21z" fill="#f3f3f3" /><circle cx="60" cy="3" fill="#00bebd" r="1" /><circle cx="56" cy="3" fill="#00bebd" r="1" /><circle cx="52" cy="3" fill="#00bebd" r="1" /><circle cx="20" cy="3" fill="#93e6e5" r="1" /><g fill="#ffac00"><path d="m21 30h-10a1 1 0 0 1 -1-1.29l3-10a1 1 0 1 1 1.92.58l-2.58 8.71h8.66a1 1 0 0 1 0 2z" /><path d="m19 34a1 1 0 0 1 -1-1v-11a1 1 0 0 1 2 0v11a1 1 0 0 1 -1 1z" /><path d="m53 30h-10a1 1 0 0 1 -1-1.29l3-10a1 1 0 1 1 1.92.58l-2.58 8.71h8.66a1 1 0 0 1 0 2z" /><path d="m51 34a1 1 0 0 1 -1-1v-11a1 1 0 0 1 2 0v11a1 1 0 0 1 -1 1z" /><path d="m35 34h-6a3 3 0 0 1 -3-3v-10a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3zm-6-14a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1z" /></g><path d="m43.54 52h-23.08l8.19-12.53a4 4 0 0 1 6.7 0z" fill="#d9d9d9" /><path d="m30.33 40.56-13.33 20.35a2 2 0 0 0 1.7 3.09h26.6a2 2 0 0 0 1.7-3.09l-13.33-20.35a2 2 0 0 0 -3.34 0z" fill="#ffac00" /><path d="m32 56a1.11 1.11 0 0 1 -1.1-1l-.7-7a1.81 1.81 0 0 1 1.8-2 1.81 1.81 0 0 1 1.8 2l-.7 7a1.11 1.11 0 0 1 -1.1 1z" fill="#f3f3f3" /><circle cx="32" cy="60" fill="#f3f3f3" r="2" /><path d="m6 39h15v2h-15z" fill="#d9d9d9" /><path d="m6 11h6v2h-6z" fill="#d9d9d9" /><path d="m6 44h10v2h-10z" fill="#d9d9d9" /><path d="m6 61a1 1 0 0 1 -.71-1.71l4-4a1 1 0 0 1 1.42 1.42l-4 4a1 1 0 0 1 -.71.29z" fill="#ffac00" /><path d="m10 61a1 1 0 0 1 -.71-.29l-4-4a1 1 0 0 1 1.42-1.42l4 4a1 1 0 0 1 -.71 1.71z" fill="#ffac00" /><path d="m54 61a1 1 0 0 1 -.71-1.71l4-4a1 1 0 0 1 1.42 1.42l-4 4a1 1 0 0 1 -.71.29z" fill="#ffac00" /><path d="m58 61a1 1 0 0 1 -.71-.29l-4-4a1 1 0 0 1 1.42-1.42l4 4a1 1 0 0 1 -.71 1.71z" fill="#ffac00" /><circle cx="55" cy="11" fill="#d9d9d9" r="1" /><circle cx="59" cy="11" fill="#d9d9d9" r="1" /><path d="m59 16a1 1 0 0 1 -.71-.29 1.81 1.81 0 0 0 -2.58 0 1 1 0 0 1 -1.42-1.42 3.84 3.84 0 0 1 5.42 0 1 1 0 0 1 -.71 1.71z" fill="#d9d9d9" /><path d="m14 11h4v2h-4z" fill="#d9d9d9" /></g></svg>
              <h1 className="mt-4"><FormattedMessage id="message_no_datafound" /></h1>
            </div>
          } */}
                {/* <div className="rounded shadow ">
            <div className="Fuel-table">
              <div
                className="table-responsive"
                style={getTableMaxHeight(height, width)}
                data-testid="table"
              >
                {allUsersData && (
                  <Grid
                    data={allUsersData}
                    columns={columns}
                    isInProgress={inProgress}
                    hiddenColumns={["Id"]}
                  />
                )}
              </div>
              </div>
              <Container fluid className="p-0">
                <Row className="tableFooter py-1">
                  <Col>
                    <small>
                      <FormattedMessage id="show" />
                     
                    </small>
                    <select
                      data-testid="pageSelect"
                      className="ms-2 from-control"
                      onChange={onPageLimitChangedForUser}
                      value={pageLimitForUser}
                    >
                      {PageLimitOptions.map((op) => (
                        <option key={op} value={op}>
                          {op}
                        </option>
                      ))}
                    </select>
                  </Col>

                  <Col className="d-flex justify-content-end">
                    <Pagination
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitForUser}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                    />
                  </Col>
                </Row>
              </Container>
            </div> */}
              </div>
            </div>
          </div>
        ) : (
          <div className="no_data_table background-image ">
            <div className="no_data w-100 text-capitalize text-center">
              <img src={NoData} alt="NOData" className="NOData" />
              <h1 className="text-capitalize fs-2">
                <FormattedMessage id="message_no_datafound" />
              </h1>
            </div>
          </div>
        )}
      </Container>
      <Footer />
    </React.Fragment>
  );
};

export default FilterPopupHOC(
  EditPopupHOC(AddPopupHOC(DeletePopupHOC(observer(User))))
);
